import styled from 'styled-components';
import Colors from '@constants/Colors';

export const Wrapper = styled.div`
  width: 400px;
  padding: 87px 32px 48px 32px;
  text-align: center;
  color: ${Colors.darkSlate};
`;

export const Title = styled.p`
  font-size: 20px;
  font-weight: 900;
  line-height: 26px;
`;

export const Text = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
`;

export const Link = styled.a`
  text-decoration: none;
  font-weight: 900;
  color: ${Colors.darkSlate};
`;

export const CloseButton = styled.button`
  padding: 12px 24px;
  color: ${Colors.periwinkleStrong};
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const Icon = styled.figure`
  width: 67px;
  height: 80px;
  background-image: url(${require('../../../../assets/images/warning-illustration.svg')});
  display: inline-block;
  margin: 0;
`;
